<template>
    <b-card>
      <template slot="header">
        <b-button @click="$router.go(-1)" class="breadcrumb-back-btn" size="sm" variant="link"><i
          class="fa fa-chevron-left fa-fw" aria-hidden="true"></i></b-button>
        {{$t('APPLICANTS')}}
      </template>
    <basic-new-form></basic-new-form>
    </b-card>
</template>

<script>
  import BasicNewForm from '@/components/applicant/basic/BasicNewForm'
    export default {
        name: "Index",
        components:{
          BasicNewForm
        }
    }
</script>

<style scoped>

</style>
